import React from "react";
import { Fragment } from "react";
import checked1 from "../../../../assets/checked1.png";

const ProcedureDelete = ({
  okayClickHandler,
  pendingappointments,
  procedureName,
  deleteprocedure,
}) => {
  return (
    <div className="procedure-delete">
      <div className="text-center mt-3 mb-2">
        <img src={checked1} />
      </div>
      <div className="text-center ">
        <h3 className="font-weight-bold">Delete Procedure</h3>
        {pendingappointments > 0 && <h4 className="h4_heading">You have {pendingappointments} appointments scheduled</h4>}
      </div>
      <div className="text-center ">
        <div className=" h5 mx-md-5 pt-md-2 pl-md-3 mb-4 frr">
          {pendingappointments > 0
            ? `If you delete ${procedureName}, all these appointments will get deleted,
          are you sure you want to delete ${procedureName}?`
            : `Once deleted, the slots will not be available for patients to book appointment. Do you want to delete ${procedureName}?`}
        </div>
        {/* <div className=" h5 mx-md-5 pt-md-2 pl-md-3 frr">Once deleted, the slots will not be available for patients to book appointment. Do you want to delete ${procedueName} ?</div> */}
      </div>
      <div className="d-flex justify-content-center align-items-start mt-3">
        <button className="sweetButton11" onClick={deleteprocedure}>
          Yes
        </button>
        <button className="sweetButton12 ml-3" onClick={okayClickHandler}>
          No
        </button>
      </div>
    </div>
  );
};

export default ProcedureDelete;
